import {
  postData,
  getData,
  putData,
  getDataGuest,
  postDataGuest,
} from 'src/utils/axios/index';
import { urlMap } from 'src/utils/urls';

export const getJobDetails = async (organizationId, jobId) => {
  const url = `${urlMap.getJobDetails}`
    .replace(`{org-id}`, organizationId)
    .replace(`{job-opening-id}`, jobId);
  return getData(url);
};

export const fetchJobOpenings = async (organizationId, payload) => {
  const url = `${urlMap.getJobOpenings}`.replace(`{org-id}`, organizationId);
  return postData(url, payload);
};

export const createNewRole = async (roleData, organizationId) => {
  const url = `${urlMap.createRole}`.replace(`{org-id}`, organizationId);
  console.log('url = ', url);
  return postData(url, roleData);
};

export const editJobDetails = async (roleData, organizationId, jobId) => {
  const url = `${urlMap.editRole}`
    .replace(`{org-id}`, organizationId)
    .replace(`{job-id}`, jobId);
  return postData(url, roleData);
};

export const createQuestions = async (
  organizationId,
  jobOpeningId,
  reqBody,
) => {
  const mapObj = {
    '{org-id}': organizationId,
    '{job-opening-id}': jobOpeningId,
  };

  const url = `${urlMap.createPacket}`.replace(
    /{org-id}|{job-opening-id}/gi,
    matched => mapObj[matched],
  );
  console.log(url);
  return postData(url, reqBody);
};

export const createPrescreeningQues = async (
  payload,
  organizationId,
  jobId,
) => {
  const url = `${urlMap.createPrescreeningQues}`
    .replace(`{org-id}`, organizationId)
    .replace(`{job-id}`, jobId);
  return postData(url, payload);
};

export const getPrescreeningQues = async (jobId, token_id) => {
  const url = `${urlMap.getPrescreeningQues}`.replace(`{job-id}`, jobId);
  return getData(url, token_id);
};

export const postPrescreeningResponse = async (payload, jobId, token_id) => {
  const url = `${urlMap.getPrescreeningResponse}`.replace(`{job-id}`, jobId);
  return postData(url, payload, token_id);
};

export const editQuestions = async (organizationId, jobOpeningId, reqBody) => {
  const mapObj = {
    '{org-id}': organizationId,
    '{job-opening-id}': jobOpeningId,
  };

  const url = `${urlMap.editPacket}`.replace(
    /{org-id}|{job-opening-id}/gi,
    matched => mapObj[matched],
  );
  console.log(url);
  return putData(url, reqBody);
};

export const getJobSuggestions = async (payload, organizationId) => {
  const url = `${urlMap.jobSuggestion}`.replace(`{org-id}`, organizationId);
  // console.log(url);

  return postData(url, payload);
};

export const getSkillSuggestions = async (payload, organizationId) => {
  const url = `${urlMap.skillSuggestion}`.replace(`{org-id}`, organizationId);
  // console.log(url);

  return postData(url, payload);
};

export const getJobDescription = async (payload, organizationId) => {
  const url = `${urlMap.getJobDescription}`.replace(`{org-id}`, organizationId);
  // console.log(url);

  return postData(url, payload);
};

export const getJobDescTextFromDoc = async payload => {
  const url = `${urlMap.getJobDescTextFromDoc}`;
  // console.log(url);

  return postData(url, payload);
};

export const getJobDescTextFromLink = async (payload, organizationId) => {
  const url = `${urlMap.getJobDescriptionFromLink}`.replace(
    `{org-id}`,
    organizationId,
  );
  // console.log(url);

  return postData(url, payload);
};

export const getPublicApplyLink = async jobId => {
  const url = `${urlMap.getPublicApplyLink}`.replace(`{job-id}`, jobId);
  // console.log(url);

  return getData(url);
};

export const getLinkDetails = async linkId => {
  const url = `${urlMap.getPublicLinkDetails}`.replace(`{link-id}`, linkId);
  return getDataGuest(url);
};

export const getPublicJobDetails = async (orgId, jobId) => {
  const url = `${urlMap.getPublicJobDetails}`
    .replace(`{org-id}`, orgId)
    .replace(`{job-id}`, jobId);
  return getDataGuest(url);
};

export const createInterviewLinkPublic = async (payload, jobId) => {
  const url = `${urlMap.createInterviewLinkPublic}`.replace(`{job-id}`, jobId);
  return postDataGuest(url, payload);
};

export const publishUnpublishLink = async (jobId, publishQuery) => {
  const url = `${urlMap.publishUnpublishLink}`
    .replace(`{job-id}`, jobId)
    .replace(`{publish-query}`, publishQuery);
  return postData(url);
};

export const archiveJob = async (orgId, jobId) => {
  const url = `${urlMap.archiveJob}`
    .replace(`{org-id}`, orgId)
    .replace(`{job-id}`, jobId);
  return postData(url);
};

export const pinJob = async (orgId, jobId) => {
  const url = `${urlMap.pinJob}`
    .replace(`{org-id}`, orgId)
    .replace(`{job-id}`, jobId);
  return postData(url);
};

export const unpinJob = async (orgId, jobId) => {
  const url = `${urlMap.unpinJob}`
    .replace(`{org-id}`, orgId)
    .replace(`{job-id}`, jobId);
  return postData(url);
};

export const getPinnedJobs = async orgId => {
  const url = `${urlMap.getPinnedJobs}`.replace(`{org-id}`, orgId);
  return getData(url);
};

export const generateCodingQuestion = async (orgId, jobId, payload) => {
  const url = `${urlMap.generateCodingQuestion}`
    .replace(`{job-opening-id}`, jobId)
    .replace(`{org-id}`, orgId);
  return postData(url, payload);
};

export const createCodingPacket = async (orgId, jobId, payload) => {
  const url = `${urlMap.createCodingPacket}`
    .replace(`{job-opening-id}`, jobId)
    .replace(`{org-id}`, orgId);
  return postData(url, payload);
};

export const getCodingPackets = async (orgId, jobId) => {
  const url = `${urlMap.getCodingPackets}`
    .replace(`{job-opening-id}`, jobId)
    .replace(`{org-id}`, orgId);
  return getData(url);
};

export const updateCodingPacket = async (orgId, packetId, payload) => {
  const url = `${urlMap.updateCodingPacket}`
    .replace(`{org-id}`, orgId)
    .replace(`{packet-id}`, packetId);
  return putData(url, payload);
};

export const createCodingInterview = async (orgId, jobId, payload) => {
  const url = `${urlMap.createCodingInterview}`
    .replace(`{org-id}`, orgId)
    .replace(`{job-opening-id}`, jobId);
  return postData(url, payload);
};

export const sendCodingInterviewEmail = async (codingInterviewId, payload) => {
  const url = `${urlMap.sendCodingInterviewEmail}`
    .replace(`{coding-interview-id}`, codingInterviewId);
  return postData(url, payload);
};

export const sendBulkJobInvite = async (payload, orgId, jobId) => {
  const url = `${urlMap.sendBulkJobInvite}`
    .replace(`{org-id}`, orgId)
    .replace(`{job-id}`, jobId);
  return postData(url, payload);
};

export const getTags = async orgId => {
  const url = `${urlMap.getTags}`.replace(`{org-id}`, orgId);
  return getData(url);
};

export const addTag = async (orgId, payload) => {
  const url = `${urlMap.addTag}`.replace(`{org-id}`, orgId);
  return postData(url, payload);
};

export const addNote = async (orgId, jobId, userId, payload) => {
  const url = `${urlMap.addNote}`
    .replace(`{org-id}`, orgId)
    .replace(`{job-opening-id}`, jobId)
    .replace(`{user-id}`, userId);
  return postData(url, payload);
};

export const deleteNote = async (orgId, jobId, noteId, payload) => {
  const url = `${urlMap.deleteNote}`
    .replace(`{org-id}`, orgId)
    .replace(`{job-opening-id}`, jobId)
    .replace(`{candidate-note-id}`, noteId);
  return postData(url, payload);
}
